"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagBA = function FlagBA(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M160.1-122V146.36L-108.25-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-27.12-22.08-23-9.87l12.87.09a1,1,0,0,1,.61,1.87L-19.93-.26-16,12a1,1,0,0,1-1.6,1.16L-28.1,5.68l-10.47,7.48A1,1,0,0,1-40.16,12L-36.28-.26-46.63-7.91A1,1,0,0,1-46-9.78l12.86-.09,4.07-12.21a1,1,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-56.54-51.5l4.07,12.2,12.86.1A1,1,0,0,1-39-37.33l-10.35,7.64,3.88,12.27a1,1,0,0,1-1.59,1.15l-10.47-7.48L-68-16.27a1,1,0,0,1-1.6-1.15l3.88-12.27-10.35-7.64a1,1,0,0,1,.61-1.87l12.87-.1,4.07-12.2a1,1,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-86-80.93l4.07,12.2,12.86.1a1,1,0,0,1,.61,1.87l-10.34,7.65,3.87,12.26a1,1,0,0,1-1.59,1.16l-10.46-7.48-10.47,7.48A1,1,0,0,1-99-46.85l3.88-12.26-10.35-7.65a1,1,0,0,1,.61-1.87l12.86-.1,4.07-12.2a1,1,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.4-110.36l4.08,12.21,12.86.1a1,1,0,0,1,.61,1.87l-10.35,7.64,3.88,12.27a1,1,0,0,1-1.59,1.15l-10.47-7.48-10.46,7.48a1,1,0,0,1-1.6-1.15l3.88-12.27-10.34-7.64a1,1,0,0,1,.6-1.87l12.87-.1,4.07-12.21a1,1,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90.58,95.62l4.07,12.2,12.87.11a1,1,0,0,1,.6,1.87l-10.34,7.64,3.88,12.26a1,1,0,0,1-1.59,1.16L89.6,123.38l-10.47,7.48a1,1,0,0,1-1.59-1.16l3.88-12.26L71.07,109.8a1,1,0,0,1,.61-1.87l12.86-.11,4.07-12.2a1,1,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.16,66.2l4.07,12.2,12.86.1a1,1,0,0,1,.61,1.87L68.35,88l3.88,12.27a1,1,0,0,1-1.59,1.15L60.18,94l-10.47,7.48a1,1,0,0,1-1.59-1.15L52,88,41.65,80.37a1,1,0,0,1,.61-1.87l12.86-.1,4.07-12.2a1,1,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.73,36.77,35.8,49l12.86.1A1,1,0,0,1,49.27,51L38.93,58.59,42.8,70.85A1,1,0,0,1,41.21,72L30.75,64.53,20.28,72a1,1,0,0,1-1.59-1.16l3.88-12.26L12.22,51a1,1,0,0,1,.61-1.88L25.69,49l4.07-12.2a1,1,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.31,7.34,6.38,19.55l12.86.1a1,1,0,0,1,.61,1.87L9.5,29.16l3.88,12.27a1,1,0,0,1-1.59,1.16L1.32,35.1-9.15,42.59a1,1,0,0,1-1.58-1.16l3.87-12.27L-17.2,21.52a1,1,0,0,1,.6-1.87l12.87-.1L.34,7.34a1,1,0,0,1,2,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-159.45-122l5.47,4-3.88,12.26a1,1,0,0,0,1.59,1.16L-145.8-112l10.46,7.48a1,1,0,0,0,1.59-1.16L-137.63-118l5.47-4Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M136.94,137.35l-12.86-.1L120,125.05a1,1,0,0,0-2,0L114,137.25l-12.86.1a1,1,0,0,0-.61,1.87l9.67,7.14h17.72l9.66-7.14a1,1,0,0,0-.61-1.87Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagBA;
exports["default"] = _default;